import { all, call, fork, put, select, takeLatest } from "redux-saga/effects";

import FeedbackService from "../../services/Feedback";
import {
  Types,
  listAllSuccess,
  setIsLoadingFeedbacks,
  getFeedbackMetricsSuccess
} from "../reducers/Feedbacks";
import { notificationMessage } from "../reducers/FeedbackMessage";

const getStoreFeedbacks = state => state.feedbacks;

const listAllRequest = async payload =>
  await FeedbackService.listAll(payload)
    .then(feedbacks => feedbacks)
    .catch(error => {
      throw error;
    });

function* listAll({ payload }) {
  try {
    yield put(setIsLoadingFeedbacks(true));
    const feedbacks = yield call(listAllRequest, payload);
    yield put(listAllSuccess(feedbacks));
  } catch (error) {
    yield put(
      notificationMessage("notifications.feedbacks.list.error", "error")
    );
  } finally {
    yield put(setIsLoadingFeedbacks(false));
  }
}

function* getFeedbackMetrics({ payload: filter }) {
  try {
    const response = yield call(FeedbackService.metrics, filter);

    yield put(
      getFeedbackMetricsSuccess({
        feedbackTotal: response.total || 0,
        feedbackResponses: response.responses || [],
        avgResponse: response.avgResponse || 0
      })
    );
  } catch (error) {
    console.error('Error fetching feedback metrics:', error);
  }
}

function* handleNewFeedback({ payload: feedback }) {
  const { feedbackMetrics: metrics } = yield select(getStoreFeedbacks);
  const oldTotal = metrics.feedbackTotal || 0;
  const feedbackResponses = metrics.feedbackResponses || [];
  const newTotal = oldTotal + 1;
  const feedbackResponse = feedback.response;
  const oldAvgResponse = metrics.avgResponse || 0;

  if (!feedbackResponse) {
    yield put(
      getFeedbackMetricsSuccess({
        feedbackTotal: newTotal,
        feedbackResponses,
        avgResponse: oldAvgResponse
      })
    );

    return;
  }

  const numericResponse = Number(feedbackResponse);
  const newAvgResponse = !isNaN(numericResponse)
    ? ((oldAvgResponse * oldTotal) + numericResponse) / newTotal
    : oldAvgResponse;

  const existingFeedbackResponse = feedbackResponses.find(r => r.response === feedbackResponse);

  if (existingFeedbackResponse) {
    existingFeedbackResponse.total = (existingFeedbackResponse.total || 0) + 1;
  } else {
    feedbackResponses.push({ response: feedbackResponse, total: 1, avgResponse: 0 });
  }

  feedbackResponses.sort((a, b) => (b.response || 0) - (a.response || 0));

  yield put(
    getFeedbackMetricsSuccess({
      feedbackTotal: newTotal,
      feedbackResponses,
      avgResponse: newAvgResponse
    })
  );
}

export function* listAllSaga() {
  yield takeLatest(Types.LIST_ALL, listAll);
}

export function* getFeedbackMetricsSaga() {
  yield takeLatest(Types.GET_FEEDBACK_METRICS, getFeedbackMetrics);
}

export function* handleNewFeedbackSaga() {
  yield takeLatest(Types.RECEIVED_NEW_FEEDBACK, handleNewFeedback);
}

export default function* rootSaga() {
  yield all([
    fork(listAllSaga),
    fork(getFeedbackMetricsSaga),
    fork(handleNewFeedbackSaga)
  ]);
}
